import React from 'react';
import { Box, Text, Title } from '@nimbus-ds/components';
import { useIsMobile } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';

const BenefitsSection = () => {
  const { t } = useTranslationWithPrefix('landing.benefitsSection');

  const isMobile = useIsMobile();

  const getBenefits = () => {
    return [
      {
        title: t('items.smartDecisions.title'),
        description: t('items.smartDecisions.description'),
      },
      {
        title: t('items.automateCollections.title'),
        description: t('items.automateCollections.description'),
      },
      {
        title: t('items.installments.title'),
        description: t('items.installments.description'),
      },
      {
        title: t('items.chargebackProtection.title'),
        description: t('items.chargebackProtection.description'),
      },
      {
        title: t('items.sellToUsa.title'),
        description: t('items.sellToUsa.description'),
      },
    ];
  };

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      gap="8"
      marginY="8"
      paddingY="4"
    >
      <Box flex="2" display="flex" flexDirection="column" gap="6">
        <Title as={isMobile ? 'h3' : 'h2'}>{t('title')}</Title>

        {isMobile ? (
          <Box display="flex" justifyContent="center">
            <img
              src="/assets/img/landing_mexico_2.svg"
              alt={t('imageAlt')}
              style={{ maxWidth: '350px', width: '100%', height: 'auto' }}
            />
          </Box>
        ) : null}

        <Box paddingLeft="2" display="flex" flexDirection="column" gap="2">
          {getBenefits().map((benefit) => (
            <Box
              key={benefit.title}
              borderWidth="none"
              borderBottomWidth="1"
              paddingBottom="4"
              paddingLeft="4"
              borderStyle="solid"
              borderColor="neutral-surfaceHighlight"
            >
              <Box marginBottom="1">
                <Title as="h5">{benefit.title}</Title>
              </Box>
              <Text>{benefit.description}</Text>
            </Box>
          ))}
        </Box>
      </Box>

      {isMobile ? null : (
        <Box
          flex="1"
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <img
            src="/assets/img/landing_mexico_2.svg"
            alt={t('imageAlt')}
            style={{ maxWidth: '520px', width: '100%', height: 'auto' }}
          />
        </Box>
      )}
    </Box>
  );
};

export default BenefitsSection;
